import Logs from './Logs'
import Servers from './Servers'
import Main from './Main'



export default {Main, Logs, Servers}